<template>
  <div class="dashboard-page">
    <aside class="sidebar">
      <h2>系统导航</h2>
      <div class="group-header">通用入口</div>
      <button class="sub-btn active">控制台</button>
      <div class="group-header mt-1" v-if="isAdmin">管理员功能</div>
      <button class="sub-btn" v-if="isAdmin" @click="goAdminHome">管理员后台</button>
      <div class="group-header mt-1" v-if="isTeacher">教师功能</div>
      <button class="sub-btn" v-if="isTeacher" @click="goTeacherQuestion">题库管理</button>
      <button class="sub-btn" v-if="isTeacher" @click="goTeacherPaper">试卷管理</button>
      <button class="sub-btn" v-if="isTeacher" @click="goTeacherExam">考试管理</button>
      <button class="sub-btn" v-if="isTeacher" @click="goTeacherGrading">阅卷管理</button>
      <button class="sub-btn" v-if="isTeacher" @click="goTeacherExamRecords">考生试卷管理</button>
      <div class="group-header mt-1" v-if="isStudent">学生功能</div>
      <button class="sub-btn" v-if="isStudent" @click="goStudentHome">学生主页</button>
    </aside>
    <main class="main-panel">
      <header class="topbar">
        <div class="topbar-left">
          <span class="topbar-title">后台管理系统首页</span>
          <span class="topbar-user">
            当前用户：{{ user.username || '未知用户' }}（{{ user.role || 'student' }}）
          </span>
        </div>
        <button class="btn btn-sm logout-btn" @click="logout">退出登录</button>
      </header>
      <section class="content-card">
        <h3>欢迎使用线上考试系统</h3>
        <p>当前页面为简化版管理首页，后续可继续扩展菜单和业务模块。</p>
        <div class="mt-3" v-if="user.role === 'teacher'">
          <button class="btn teacher-btn" @click="goTeacherQuestion">
            进入题库管理（教师端）
          </button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'DashboardView',
  data() {
    return {
      user: {}
    }
  },
  created() {
    try {
      this.user = JSON.parse(localStorage.getItem('exam_user') || '{}')
    } catch (e) {
      this.user = {}
    }
  },
  computed: {
    roleNormalized() {
      return String(this.user.role || '').toLowerCase()
    },
    isAdmin() {
      return this.roleNormalized === 'admin'
    },
    isTeacher() {
      return this.roleNormalized === 'teacher'
    },
    isStudent() {
      return this.roleNormalized === 'student'
    }
  },
  methods: {
    goTeacherQuestion() {
      window.location.hash = '#/teacher/questions'
    },
    goTeacherPaper() {
      localStorage.setItem('teacher_active_menu', 'paper')
      window.location.hash = '#/teacher/papers'
    },
    goTeacherExam() {
      localStorage.setItem('teacher_active_menu', 'exam')
      window.location.hash = '#/teacher/papers'
    },
    goTeacherGrading() {
      localStorage.setItem('teacher_active_menu', 'grading')
      window.location.hash = '#/teacher/papers'
    },
    goTeacherExamRecords() {
      window.location.hash = '#/teacher/exam-records'
    },
    goAdminHome() {
      window.location.hash = '#/admin/home'
    },
    goStudentHome() {
      window.location.hash = '#/student/home'
    },
    logout() {
      localStorage.removeItem('exam_user')
      window.location.hash = '#/'
    }
  }
}
</script>

<style scoped>
.dashboard-page {
  min-height: 100vh;
  display: flex;
  background:
    radial-gradient(circle at 8% 10%, rgba(75, 133, 255, 0.26), transparent 34%),
    radial-gradient(circle at 90% 18%, rgba(52, 190, 255, 0.2), transparent 30%),
    linear-gradient(150deg, #081734, #0c2450 48%, #0a1b3f);
  color: #dce9ff;
}

.sidebar {
  width: 220px;
  padding: 24px 18px;
  background: rgba(9, 28, 64, 0.88);
  border-right: 1px solid rgba(132, 169, 245, 0.3);
}

.sidebar h2 {
  color: #e7f1ff;
  font-size: 20px;
  margin-bottom: 20px;
}

.sidebar ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.sidebar li {
  padding: 10px 12px;
  margin-bottom: 10px;
  border-radius: 10px;
  background: rgba(21, 62, 124, 0.7);
  border: 1px solid rgba(138, 174, 243, 0.35);
  color: #dce9ff;
}

.group-header {
  font-size: 12px;
  font-weight: 700;
  color: #5c7098;
  letter-spacing: 0.4px;
  margin-bottom: 6px;
}

.sub-btn {
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  margin-bottom: 8px;
  border-radius: 10px;
  border: 1px solid #d8e6ff;
  background: #f6f9ff;
  color: #335896;
}

.sub-btn.active {
  background: linear-gradient(120deg, #2f6feb, #5ca2ff);
  color: #ffffff;
  border-color: transparent;
}

.main-panel {
  flex: 1;
  padding: 20px;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-radius: 12px;
  background: rgba(11, 33, 76, 0.8);
  border: 1px solid rgba(138, 174, 243, 0.35);
}

.topbar-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.topbar-title {
  font-weight: 700;
  color: #f3f7ff;
}

.topbar-user {
  color: #afc8f2;
  font-size: 13px;
}

.logout-btn {
  border: none;
  color: #ffffff;
  background: linear-gradient(120deg, #2f6feb, #5da9ff);
}

.content-card {
  margin-top: 16px;
  padding: 24px;
  border-radius: 14px;
  background: rgba(11, 33, 76, 0.8);
  border: 1px solid rgba(138, 174, 243, 0.35);
}

.teacher-btn {
  border: none;
  color: #ffffff;
  background: linear-gradient(120deg, #2f6feb, #5da9ff);
}
</style>
